import gql from "graphql-tag";

export const DOCUMENT_FIELDS = gql`
  fragment DocumentFields on Document {
				id
				identifier
				source {
					id
					code
					description
				}
				tenant
				status
				description
				comment
				audits {
					id
					timeStamp
					userIdentifier
					source
					severity
					type
					message
				}
				validations {
					id
					timeStamp
					userIdentifier
					validator
					severity
					severity
					field
					message
				}
				files {
					id
					name
					extension
					deleted
					type,
					groupId,
					parentGroupId,
					timeStamp
				}
				taskToken
				logs {
					id
					severity
					timeStamp
					message
					source
				}
				created
				processed
				deleted
				metaData {
					documentId,
					id
					key
					value
					timeStamp
					valueType
					selected
					confidence
					source
					changed
				}
  }
`;
